import { BsFillGridFill, BsBook, BsPersonSquare, BsFilePlus, BsViewList, BsListUl, 
    BsClipboardData, BsPeopleFill, BsPersonPlusFill, BsEnvelope ,BsPen
} from 'react-icons/bs'

const menuList = [
    {
        name: "หน้าหลัก",
        path: "/dashboard",
        icon: BsFillGridFill
    },
    {
        name: "ตรวจสอบลำดับคิว",
        path: "/queue",
        roles: [5],
        icon: BsViewList
    },
    {
        divider: true,
        roles: [1, 2],
        title: 'จัดการคำร้อง'
    },
    {
        name: "รายการคำร้องใหม่",
        roles: [1, 2],
        path: "/newforms",
        icon: BsClipboardData
    },
    {
        name: "รายการคำร้องทั้งหมด",
        roles: [1, 2],
        path: "/forms",
        icon: BsListUl
    },
    {
        divider: true,
        roles: [1, 2],
        title: 'ลำดับการทำสัญญา'
    },
    {
        name: "จัดการลำดับคิว",
        path: "/queue",
        roles: [1, 2],
        icon: BsViewList
    },
    {
        name: "จัดการสัญญา",
        path: "/contract",
        roles: [1, 2],
        icon: BsPen
    },
    {
        divider: true,
        roles: [4],
        title: "สำหรับผู้พักอาศัย"
    },
    {
        name: "ประวัติคำร้องและคิว",
        path: "/history",
        roles: [4],
        icon: BsPen
    },
    {
        divider: true,
        roles: [5],
        title: "สำหรับผู้ใช้งาน"
    },
    {
        name: "ยื่นแบบคำร้อง",
        roles: [5],
        path: "/formagree",
        icon: BsFilePlus
    },
    {
        divider: true,
        roles: [1],
        title: "สำหรับผู้ดูแลระบบ"
    },
    {
        name: "บัญชีผู้ใช้ทั้งหมด",
        roles: [1],
        path: "/users",
        icon: BsPeopleFill
    },
    {
        name: "เพิ่มบัญชีผู้ใช้",
        roles: [1],
        path: "/adduser",
        icon: BsPersonPlusFill
    },
    {
        divider: true,
        roles: [1, 2],
        title: 'ตั้งค่า'
    },
    {
        name: "รูปแบบอีเมล",
        roles: [1, 2],
        path: "/email",
        icon: BsEnvelope
    },
    {
        divider: true
    },
    {
        name: "บัญชีผู้ใช้",
        path: "/profile",
        icon: BsPersonSquare
    },
    {
        name: "กฎ ระเบียบ",
        path: "/regulations",
        icon: BsBook
    },
    {
        name: "คู่มือการใช้งาน",
        path: "/manual",
        icon: BsBook
    }
]

export default menuList